import React, {
    useMemo, useState,
} from 'react'
import PropTypes from 'prop-types'
import EvidenceContext from './EvidenceContext'

const propTypes = { children: PropTypes.element.isRequired }

const EvidenceContextProvider = ({ children }) => {
    const [
        currentEvidence,
        setCurrentEvidence,
    ] = useState(
        { evidenceId: null },
    )

    const value = useMemo(() => {
        return {
            evidence: currentEvidence,
            saveEvidence: setCurrentEvidence,
        }
    }, [currentEvidence])

    return (
        <EvidenceContext.Provider
            value={value}
        >
            {children}
        </EvidenceContext.Provider>
    )
}

EvidenceContextProvider.propTypes = propTypes

export default EvidenceContextProvider
